export class ManageListActionSettings {
}
export var ManageListSettingsAction;
(function (ManageListSettingsAction) {
    ManageListSettingsAction["Add"] = "Add";
    ManageListSettingsAction["Remove"] = "Remove";
})(ManageListSettingsAction || (ManageListSettingsAction = {}));
